export const SmcTemplateKeysDict = {
  inheritanceDigitalPath: 'INHERITANCE_DIGITAL_PATH',
  inheritanceMissingDeathCert: 'MISSING_DEATH_CERTIFICATE',
  giftingDigitalPath: 'GIFTING_DIGITAL_PATH',
  internalTransferDigitalPath: 'INTERNAL_TRANSFER_DIGITAL_PATH',
};

export const enum SmcResponseMessageEnum {
  SUCCESS_MSG = 'SMC Webservice Success',
  FAILURE_MSG = 'SMC Webservice Failed',
}
